<template>
  <div>
    <section class="hero is-info" style="margin-bottom: 15px">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            <span style="text-transform: capitalize">{{ directionString }}</span> Trip
          </h1>
          <div v-if="fromLocality && toLocality">
            <h2 class="subtitle" v-if="direction === 0">
              {{ fromLocality }} to {{ toLocality }}
            </h2>
            <h2 class="subtitle" v-else>
              {{ toLocality }} to {{ fromLocality }}
            </h2>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <b-tabs v-model="direction" position="is-centered">
        <b-tab-item label="Departing">
        </b-tab-item>
        <b-tab-item label="Returning" v-if="rItin">
        </b-tab-item>
      </b-tabs>
      <timeline v-if="direction === 0 ? dItin : rItin"
                :startString="(direction === 0 ? fromLocality : toLocality) || 'Start'"
                :endString="(direction === 0 ? toLocality : fromLocality) || 'End'"
                :segments="direction === 0 ? dItin.departing_segments : rItin.returning_segments "></timeline>
    </div>

  </div>
</template>

<script>
import Timeline from './Timeline';
import axios from 'axios';
import format from 'date-fns/format'
  ;

export default {
  name: 'Cart',
  props: ['searchId', 'fromLocality', 'toLocality', 'departingItinerary', 'returningItinerary'],
  components: {
    timeline: Timeline,
  },
  computed: {
    directionString() {
      return this.direction === 0 ? 'Departing' : 'Returning';
    },
  },
  data() {
    return {
      iconsMap: {
        'ride-share': 'uber',
        drive: 'car',
        bus: 'bus',
        flight: 'airplane',
      },
      direction: 0,
      dItin: this.departingItinerary,
      rItin: this.returningItinerary,
    };
  },
  mounted() {
    const self = this;
    const returningItineraryId = this.$route.query.returningItinerary;
    if (!this.dItin) {
      // axios.get(`http://www.zegmentodemo.com:9999/itineraries/${this.$route.query.departingItinerary}`)
      //   .then((response) => {
      //     self.dItin = response.data.data;
      //   })
      //   .catch((error) => {
      self.$router.replace({ name: 'Search' });
      // });
    }
    if (!this.rItin && returningItineraryId) {
      // axios.get(`http://www.zegmentodemo.com:9999/itineraries/${returningItineraryId}`)
      //   .then((response) => {
      //     self.rItin = response.data.data;
      //   })
      //   .catch((error) => {
      self.$router.replace({ name: 'Search' });
      // });
    }
  },
  methods: {
    format(dt) {
      return format(dt, 'h:mma');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@keyframes pound {
  from {
    transform: none;
  }
  50% {
    transform: scale(1.4);
  }
  to {
    transform: none;
  }
}

.pulse {
  /* ... */
  animation: pound 2s infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue